<script>
    import { createEventDispatcher } from "svelte";

    export let title = null;
    export let disabled = false;

    const dispatcher = createEventDispatcher();

    const deleteItem = () => {
        dispatcher("delete");
    };

    let className = $$props.class ? " " + $$props.class : "";
</script>

<button
    class={className}
    on:click|preventDefault={deleteItem}
    {disabled}
    type="submit"
    {title}
>
    <slot></slot>
</button>

<style>
    button {
        position: relative;
        color: var(--color-body);
        background-color: transparent;
        border: none;
        padding: 0;
        padding-left: 30px;
        font-family: "Proxima Nova";
        font-size: 18px;
        font-weight: 600;
    }

    button:before {
        position: absolute;
        content: "\00d7";
        font-size: 2rem;
        line-height: 1;
        left: 0;
        top: -6px;
    }
</style>
